import { Link } from 'react-router-dom';
import { Mail, MapPin, Calendar } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { DemoButton } from '@/components/DemoCTA';


const Footer = () => {
  const { t, language } = useLanguage();
  return (
    <footer className="bg-gradient-dark border-t border-border">
      {/* Final CTA strip */}
      <div className="border-b border-border bg-gradient-to-r from-primary/10 via-accent/5 to-primary/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 text-xs font-mono tracking-widest text-accent mb-2">
              <Calendar className="h-3.5 w-3.5" /> {language === 'fr' ? 'PROCHAINE ÉTAPE' : language === 'es' ? 'PRÓXIMO PASO' : 'NEXT STEP'}
            </div>
            <h3 className="text-2xl md:text-3xl font-extrabold text-foreground leading-tight">
              {language === 'fr'
                ? 'Voyez QuantumBox en action — 15 min, sans engagement.'
                : language === 'es'
                ? 'Mira QuantumBox en acción — 15 min, sin compromiso.'
                : 'See QuantumBox in action — 15 min, no commitment.'}
            </h3>
          </div>
          <DemoButton size="lg" />
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-4 group">
              <div className="relative">
                <img src="/lovable-uploads/13ccca33-efca-4b7f-9ef1-50aafecd8c64.png" alt="QuantumBox AI Logo" className="h-10 w-10 group-hover:animate-glow-pulse transition-tech" />
                <div className="absolute inset-0 bg-gradient-tech opacity-20 rounded-lg group-hover:opacity-30 transition-tech" />
              </div>
              <span className="text-xl font-bold bg-gradient-tech bg-clip-text text-transparent">
                QuantumBox AI
              </span>
            </Link>
            <p className="text-muted-foreground mb-4 max-w-md">
              {t('footer.description')}
            </p>
            <div className="space-y-2 text-sm text-muted-foreground">
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <span>admin@quantumbox.ai</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4" />
                <span>Paris, France</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t('footer.services')}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/services" className="hover:text-primary transition-tech">{t('footer.neural.networks')}</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-tech">{t('footer.quantum.security')}</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-tech">{t('footer.edge.computing')}</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-tech">{t('footer.ai.orchestration')}</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-tech">{t('footer.neural.consulting')}</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-primary transition-tech">{t('footer.about')}</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-tech">{t('footer.contact')}</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-tech">{t('footer.architecture')}</Link></li>
              <li><Link to="/" className="hover:text-primary transition-tech">{t('footer.neural.research')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;